import { useMutation } from 'react-query';
import { axiosInstance } from '../../config/axios';

interface InsertIksTerminalRequestPayload {
  merchantId: number;
  bankCode: string;
  type: string;
}

const insertIksTerminalRequest = async (payload: InsertIksTerminalRequestPayload) => {
  const response = await axiosInstance.post('/MerchantIKS/InsertIKSTerminalRequest', payload);
  return response.data;
};

export const useInsertIksTerminalRequest = () => {
  return useMutation(insertIksTerminalRequest);
};
